import React from 'react';
import './MainLogo.scss';
import { NavLink } from 'react-router-dom';

const MainLogo = (): JSX.Element => {
  return (
    <div className="mainLogo">
      <NavLink to="/">
        <div className="logo"></div>
        <h2>Наш город</h2>
      </NavLink>
    </div>
  );
};

export default MainLogo;
